// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3caVS","content":"RecentSearches_content__5_yFm"};